import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface InfoPercentType {
  commission_min_amount: number;
  commission_percent: number;
}
export interface AuthState {
  token: string | null;
  is_contract_signed: boolean;
  balance: string | number;
  hold: string | number;
  to_be_paid: string | number;
  infoPercent: InfoPercentType;
  min_order_amount: number;
  max_order_amount: number;
  name: string;
  avatar: string | null;
  fio: string;
}

const initialState: AuthState = {
  token: localStorage.getItem('token') ?? null,
  is_contract_signed: false,
  balance: 0,
  hold: 0,
  to_be_paid: 0,
  infoPercent: {
    commission_min_amount: 0,
    commission_percent: 0,
  },
  min_order_amount: 0,
  max_order_amount: 0,
  name: '',
  avatar: null,
  fio: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logIn(state: { token: string | null }, action: PayloadAction<string | null>): void {
      state.token = action.payload;
    },
    logOut(state) {
      state.token = null;
    },
    setIsContractSigned(state, action) {
      state.is_contract_signed = action.payload;
    },
    setBalance(state, action) {
      state.balance = action.payload.balance;
      state.min_order_amount = action.payload.min_order_amount;
      state.max_order_amount = action.payload.max_order_amount;
      state.hold = action.payload.hold;
      state.to_be_paid = action.payload.to_be_paid;
      state.infoPercent = action.payload.infoPercent;
    },
    setInfo(state, action) {
      state.avatar = action.payload.avatar;
      state.name = action.payload.name;
      state.fio = action.payload.fio;
    },
  },
});

export const { logIn, logOut, setIsContractSigned, setBalance, setInfo } =
  authSlice.actions;
export default authSlice.reducer;
